import { render, staticRenderFns } from "./ThemeDetailView.vue?vue&type=template&id=a3dcc870&scoped=true&"
import script from "./ThemeDetailView.vue?vue&type=script&lang=js&"
export * from "./ThemeDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDetailView.vue?vue&type=style&index=0&id=a3dcc870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dcc870",
  null
  
)

export default component.exports